var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 3,
    fill: "#FF439B",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8955 21.0264L11.9299 20.0609C11.6643 19.7953 11.5705 19.4109 11.6893 19.0547C11.783 18.7766 11.908 18.4141 12.058 17.9986H8.75194C8.48321 17.9986 8.23322 17.8548 8.09885 17.6205C7.96449 17.3861 7.96761 17.0986 8.1051 16.8674L9.74564 14.102C10.1519 13.4176 10.8862 12.9989 11.6799 12.9989H14.2517C14.3267 12.8739 14.4016 12.7583 14.4766 12.6458C17.0359 8.87112 20.8482 8.74613 23.1231 9.16485C23.4856 9.23047 23.7668 9.51482 23.8355 9.87729C24.2543 12.1552 24.1261 15.9643 20.3545 18.5235C20.2451 18.5985 20.1264 18.6735 20.0014 18.7485V21.3202C20.0014 22.1139 19.5826 22.8513 18.8983 23.2544L16.1328 24.8949C15.9016 25.0324 15.6141 25.0355 15.3797 24.9011C15.1454 24.7668 15.0016 24.5199 15.0016 24.2481V20.8983C14.561 21.0514 14.1767 21.1764 13.8861 21.2702C13.5361 21.3827 13.1548 21.2858 12.8924 21.0264H12.8955ZM20.0014 14.2488C20.3329 14.2488 20.6508 14.1172 20.8852 13.8827C21.1196 13.6483 21.2513 13.3304 21.2513 12.9989C21.2513 12.6674 21.1196 12.3495 20.8852 12.1151C20.6508 11.8807 20.3329 11.749 20.0014 11.749C19.6699 11.749 19.3519 11.8807 19.1175 12.1151C18.8831 12.3495 18.7514 12.6674 18.7514 12.9989C18.7514 13.3304 18.8831 13.6483 19.1175 13.8827C19.3519 14.1172 19.6699 14.2488 20.0014 14.2488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.2424b8a16625db3915fffc5eafcbdf4a.svg";
export { ForwardRef as ReactComponent };